/** Nº de colunas da grelha (1 “sem cor” + cores = 2 linhas fixas no popover). */
export const PRIMARY_HEX_PALETTE_GRID_COLS = 11;

/**
 * Paleta primária (atalhos).
 * Com botão “sem cor”: 1 + length = 22 → 2 linhas × 11 colunas.
 */
export const PRIMARY_HEX_PALETTE = [
  '#FFFFFF',
  '#000000',
  '#EF4444',
  '#F472B6',
  '#C084FC',
  '#6366F1',
  '#2563EB',
  '#22D3EE',
  '#14B8A6',
  '#10B981',
  '#84CC16',
  '#EAB308',
  '#FB923C',
  '#EA580C',
  '#15803D',
  '#6D28D9',
  '#475569',
  '#94A3B8',
  '#F43F5E',
  '#8B5CF6',
  '#0EA5E9',
] as const;

/**
 * Aceita `#RRGGBB`, `#RGB`, `RRGGBB` ou `RGB` (sem #). Retorna sempre `#RRGGBB` em maiúsculas ou null.
 */
export function tryParseHexInput(value: string): string | null {
  let s = value.trim().toUpperCase();
  if (!s) return null;
  if (!s.startsWith('#')) {
    if (/^[0-9A-F]{6}$/.test(s)) {
      s = `#${s}`;
    } else if (/^[0-9A-F]{3}$/.test(s)) {
      const [r, g, b] = [s[0], s[1], s[2]];
      s = `#${r}${r}${g}${g}${b}${b}`;
    } else {
      return null;
    }
  }
  if (/^#[0-9A-F]{6}$/.test(s)) return s;
  if (/^#[0-9A-F]{3}$/.test(s)) {
    const r = s[1];
    const g = s[2];
    const b = s[3];
    return `#${r}${r}${g}${g}${b}${b}`;
  }
  return null;
}

export function normalizeHexOrFallback(value: string, fallback: string): string {
  return (
    tryParseHexInput(value) ??
    tryParseHexInput(fallback) ??
    '#E2E8F0'
  );
}

export function hexColorsEqual(a: string, b: string, fallback: string): boolean {
  return normalizeHexOrFallback(a, fallback) === normalizeHexOrFallback(b, fallback);
}

export function isLightHexColor(colorHex: string): boolean {
  const parsed = tryParseHexInput(colorHex);
  const hex = parsed ?? colorHex.trim().toUpperCase();
  if (!/^#[0-9A-F]{6}$/.test(hex)) {
    return hex === '#FFFFFF' || hex === '#E2E8F0';
  }
  const n = parseInt(hex.slice(1), 16);
  const r = (n >> 16) & 255;
  const g = (n >> 8) & 255;
  const b = n & 255;
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.76;
}
